<template>
  <v-container fluid>
    <v-col cols="9" sm="6" md="4" class="ml-auto mr-auto">
      <v-card class="elevation-2 px-5 rounded-lg py-7 mt-10">
        <v-form ref="form" v-if="!success" lazy-validation>
          <div class="text-h5 font-weight-bold text-center indigo--text mb-5">Password Recovery</div>
          <v-text-field
              v-model="username"
              label="Email"
              :rules="emailRules"
              required
              outlined
              dense
          ></v-text-field>
          <v-btn class="mr-4 white--text" @click="submit" color="indigo" block :disabled="disabled">
            Continue
          </v-btn>
          <p class="forgot-link">
            <router-link class="nav-link menu" to="/login">Back to Login</router-link>
          </p>
        </v-form>
        <div v-if="success">
          <p style="text-align: center">
            Check your e-mail, shortly you will receive instructions to reset your password.</p>
          <v-btn class="mr-4 white--text" color="indigo" block to="login">
            Back to Login
          </v-btn>
        </div>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      username: "",
      disabled: false,
      success: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    };
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.disabled = true
      this.success = false
      axios.post("/forgot-password", {
        username: this.username,
      }).then(() => {
        this.success = true
        this.disabled = false
      })
    },
  },
};
</script>

<style scoped>
.forgot-link {
  padding-top: 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;
  color: #3F51B5;
}

.forgot-link a {
  text-decoration: none;
}
</style>